<template>
    <div
        :class="[
            'bokeh-block',
            'object-list',
            this.layout.object
        ]"
    >
        <div class="filter-caption-container" v-if="layout.object !== 'technique'">
            <span class="current-filter-list">
                <span
                    v-if="currentTerm.name"
                    class="current-filter"
                    @click="updateTerms(currentTerm)"
                >{{currentTerm.name}} <IconPlus class="close"/>
                </span>
                <span
                    class="current-filter"
                    v-for="[filter, i] in currentFilters"
                    v-bind:key="i"
                    @click="deleteFilter(filter)"
                >{{filter.name}} <IconPlus class="close"/>
                </span>
            </span>
            <LinkHover :type="'button'" @click.native="filter = !filter">
                <span class="default filter-caption">
                    <span :class="['filter-label-caption', {
                        hidden: filtersLength > 0
                    }]">{{filter ? $t('common.reduce') : $t('common.filterby')}}</span>
                    <a class="toggle-filter"><IconArrow :direction="filter ? 'top' : 'down'"/></a>
                </span>
                <template v-slot:hover>
                    <span class="hover filter-caption">
                        <span :class="['filter-label-caption', {
                            hidden: filtersLength > 0
                        }]">{{filter ? $t('common.reduce') : $t('common.filterby')}}</span>
                        <a class="toggle-filter"><IconArrow :direction="filter ? 'top' : 'down'"/></a>
                    </span>
                </template>
            </LinkHover>
        </div>
        <transition name="fade">
            <div v-show="filter" class="filters">
                <FilterBox
                    v-if="!layout.filter_by_taxonomy"
                    @updateFilter="updateFilter"
                    :filters="filters"
                />
                <TaxonomyFilter
                    v-else
                    @updateFilter="updateTerms"
                    :filters="layout.taxonomy"
                    :current-term="currentTerm"
                />
            </div>
        </transition>
        <div
            v-if="!storyMode"
        >
            <Thumb
                :key="_.id"
                :data="_"
                v-for="_ in layout.data"
            />
        </div>
        <div
            v-else
            class="thumb-container"
        >
            <component
                v-for="board in layout.data"
                :key="board.id"
                :is="getBoardType(board)"
                :layout="board"
                :taxonomy="layout.taxonomy"
                class="board"
            />
        </div>
        <div
            @click="moreObjects"
            class="more-objects"
        >
            <Cta
                v-if="!end && !storyMode"
                class="cta"
                :caption="$t('cta.more.projects')"
            />
        </div>
    </div>
</template>
<script>
import { getPosts } from '@/store/api/index'
import FilterBox from '@/views/Projects/FilterBox'
import TaxonomyFilter from '@/components/layout/ObjectList/TaxonomyFilter'
import Thumb from '@/components/Thumb'
import IconArrow from '@/components/IconArrow'
import IconPlus from '@/components/IconPlus'
import Cta from '@/components/HugeCta'
import LinkHover from '@/components/animation/LinkHover'
import Externallink from '@/components/layout/Board/ExternalLink'
import Highlight from '@/components/layout/Board/Highlight'
import Project from '@/components/layout/Board/Project'
import Story from '@/components/layout/Board/Story'
import Narrative from '@/components/layout/Board/Narrative'
import Picture from '@/components/layout/Board/Picture'
export default {
    components: {
        FilterBox,
        Thumb,
        IconArrow,
        IconPlus,
        TaxonomyFilter,
        LinkHover,
        Cta,
        Externallink,
        Highlight,
        Project,
        Story,
        Narrative,
        Picture
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            page: 1,
            end: false,
            filter: false,
            filters: {},
            currentTerm: {}
        }
    },
    computed: {
        storyMode() {
            return this.layout.object === 'story'
        },
        currentFilters() {
            return this.filters
        },
        filtersLength() {
            return Object.keys(this.filters).length +  Object.keys(this.currentTerm).length
        }
    },
    created() {
        if(this.layout.data.length < this.layout.pagination || this.layout.pagination < 0) {
            this.end = true
        }
    },
    methods: {
        getBoardType(board) {
            if (board.type === 'project') {
                return 'project'
            } else if (board.category === 'highlight' && board.highlight.pictured) {
                return 'Picture'
            }
            return board.category
        },
        moreObjects()
        {
            const filters = this.mergeFilters()
            getPosts({
                type: this.layout.object,
                paged: this.layout.object === 'story'? undefined : this.page + 1,
                perpage: this.layout.pagination,
                metaquery: filters.metaquery,
                countries: filters.countries,
                lang: this.$route.params.locale
            })
                .then(res => {
                    if(res.length < this.layout.pagination) {
                        this.end = true
                    }
                    this.mergeObject(res);
                    this.page++;
                })
        },
        mergeObject(data) {
            data.forEach(item => {
                if(!this.layout.data.find(thumb => thumb.slug === item.slug)) {
                    this.layout.data.push(item);
                }
            })
        },
        mergeFilters() {
            const metaquery = []
            const countries = []
            for (var key in this.filters) {
                if ( this.filters.hasOwnProperty(key)) {
                    if(key === 'country' || key === 'region') {
                        countries.push(this.filters[key].id)
                    } else {
                        metaquery.push(this.filters[key].id)
                    }
                }
            }
            if(this.currentTerm.term_id) {
                metaquery.push(this.currentTerm.term_id)
            }
            return {
                metaquery: encodeURIComponent(metaquery),
                countries: encodeURIComponent(countries)
            }
        },
        deleteFilter(filter) {
            this.$delete(this.filters, filter.type)
            if(filter.type === 'market') {
                this.$router.replace({hash: null})
            }
            this.layout.data = []
            this.page = 0
            this.end = false
            this.moreObjects()
        },
        updateFilter(filter) {
            // if(filter.type === 'market') {
            //     this.$router.replace({hash: `#${filter.customslug}`})
            // }
            this.layout.data = []
            this.page = 0
            this.end = false
            if(this.filters[filter.type] && filter.id === this.filters[filter.type].id) {
                this.$delete(this.filters, filter.type)
            } else {
                this.$set(this.filters, filter.type, filter)
            }
            if((filter.type === 'country' && this.filters[filter.type]) || (filter.type === 'region' && !filter.active)) {
                this.$delete(this.filters, 'region')
            }
            if((filter.type === 'region' && this.filters[filter.type]) || (filter.type === 'region' && !filter.active)) {
                this.$delete(this.filters, 'country')
            }
            this.moreObjects()
        },
        updateTerms(term) {
            this.layout.data = []
            this.currentTerm = term.term_id === this.currentTerm.term_id ? {} : term
            this.moreObjects()
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.filters
    position: absolute
    left: 0
    right: 0
    z-index: 2
    @media print
        display: none
.bokeh-block
    overflow: hidden
    @include media-breakpoint-down($sm)
        margin-left: 9.6%
        margin-right: 9.6%
    @media print
        margin-left: 9.6%
        margin-right: 9.6%
.filter-caption-container
    text-align: right
    margin-bottom: 3%
    display: flex
    justify-content: flex-end
    @include media-breakpoint-down($sm)
        margin-bottom: 12%
        .filter-label-caption
            &.hidden
                display: none
    @media print
        margin-bottom: .3cm
        button
            display: none


.current-filter-list
    display: flex
    align-items: center
    justify-content: flex-end
    @include media-breakpoint-down($sm)
        flex-direction: column
        align-items: flex-end
.current-filter
    display: flex
    justify-content: center
    align-items: center
    margin-right: 90px
    @include media-breakpoint-down($sm)
        margin-right: 0
        font-size: 12px
    cursor: pointer
    .close
        transform: rotate(45deg)
        width: 20px
        height: 20px
        margin-left: 17px
        /deep/ path
            fill: rgb(99, 103, 114)
.filter-caption
    color: #ff2b2a
    font-size: 17px
    font-weight: 500
    display: flex
    justify-content: flex-end
    align-items: center
    white-space: nowrap
    .toggle-filter
        display: block
        border: 1px solid #ff2b2a
        width: 75px
        height: 75px
        margin-left: 25px
        display: flex
        align-items: center
        justify-content: center
        @include media-breakpoint-down($sm)
            width: 54px
            height: 54px
        svg
            /deep/ path
                fill: #ff2b2a
    &.hover
        color: rgba(0,0,0,0)
        .toggle-filter
            border: 1px solid #ff2b2a
            background: #ff2b2a
            svg
                /deep/ path
                    fill: #FFFFFF
.article-link
    display: block
.cta
    width: 100%
.story
    .thumb-container
        display: flex
        flex-wrap: wrap
        justify-content: center
        @media print
            display: block
.board
    border: 1px solid #e5e5e5
    &:after
        display: none

    @include media-breakpoint-down($lg)
        max-width: 50%
    @include media-breakpoint-down($md)
        max-width: 100%
    @include media-breakpoint-down($sm)
        width: 100%
        margin-left: 0
        margin-right: 0
    @media print
        display: block
        width: auto
        height: auto
        border: none
        margin-bottom: 1.2cm
        page-break-inside: avoid
        break-inside: avoid
        max-width: 100%
        margin-left: 0
        margin-right: 0

    /deep/ .default,
    /deep/ .hover,
    &.highlight
        padding-top: 178px
        padding-right: 75px
        padding-bottom: 85px
        padding-left: 85px
        @media print
            padding: 0
        @include media-breakpoint-down($sm)
            padding: 45px 15px 39px 15px
            @media print
                padding: 0
    /deep/ .footer
        @media print
            svg
                display: none
// .highlight
//     /deep/ .container
//         padding-top: 178px
//         padding-right: 75px
//         padding-bottom: 85px
//         padding-left: 85px
//         @media print
//             padding: 0
//         @include media-breakpoint-down($sm)
//             padding: 45px 15px 39px 15px
//             @media print
//                 padding: 0
a.board
    @media print
        &:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
            display: block
            position: static
            top: initial
            left: initial
            bottom: initial
            right: initial
            width: auto
            margin-bottom: 0
            padding-bottom: 0
@media print
    .more-objects
        display: none
</style>
